import styled from "@emotion/styled";
import { GetPageQuery } from "apollo";
import { Article } from "lib/articles";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import { ButtonToUsefullInfoPage } from "pazChargeComponents/useful-information/ArticleDynamicPage";
import MoreArticlesSwiper from "pazChargeComponents/useful-information/MoreArticlesSwiper";
import {  TitleWithLine, extractProperty } from "ui";

const StyledTitleWithLine = styled(TitleWithLine)`
display: flex;
align-items: center;
justify-content: start;
`

const StyledWrapper = styled.div`
  padding-bottom: 40px;
  padding-top: 60px;
  background-color: rgba(21, 62, 105, 0.1);
    ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
  }
`
const StyledMobilePadding = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    padding-left: 20px;
  }
`

type Props = {
  data: GetPageQuery
  articles: Article[]
}


function UsefulInfoBlockCharge({ data, articles }: Props) {
  const blockTitle = extractProperty(data, "blockTitle")
  return (
    <StyledWrapper>
      <ContainerWrapper withoutPadding >
        <StyledMobilePadding>
          <StyledTitleWithLine
            title={blockTitle}
            mobileTitleFontSize={24}
            titleFontSize={34}
            noMobileMargin
            titleColor="black"
            component={"h2"}
          />
          <MoreArticlesSwiper articles={articles} />
          <ButtonToUsefullInfoPage />
        </StyledMobilePadding>
      </ContainerWrapper>
    </StyledWrapper>
  );
}

export default UsefulInfoBlockCharge;
